<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="languageSummary && languageProgress">
			<title-bar title="Progreso" :percentage="languageSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="languageSummary.itemName" :percentage="languageSummary.itemPercentage" percentageTitle="Promedio Idioma"/>
			<div class="col full">
				<div class="row between innerRubric">
					<progress-chart v-for="category in progressionReport.coachingCategories" :key="category.id" :categoryId="category.id" :data="category.graphData" :title="category.name" :percentage="category.percentage"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['isoCode'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		languageSummary () {
			if (this.$store.state.languages.summary) return this.$store.state.languages.summary.find((item) => {
				return item.itemId == this.isoCode;
			});
			else return this.$store.state.languages.summary;
		},
		languageProgress () {
			if (this.$store.state.languages.progress) return this.$store.state.languages.progress.find((item) => {
				return item.language.isoCode == this.isoCode;
			}).progress;
			else return this.$store.state.languages.progress;
		},
		progressionReport () {
			if (!this.languageProgress) return [];
			this.languageSummary.coachingCategories.forEach((coachingCategory) => {
				coachingCategory.graphData = {
					labels: this.languageProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == coachingCategory.id) result = parseInt(category.percentage);
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.languageProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == coachingCategory.id) result = parseInt(category.percentage);
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.languageProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
			});
			return this.languageSummary;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/languages/CategoriesProgress.vue